import { Api } from '@axiom/ui';
import type {
  UserAlerts,
  UserFixedAlerts,
  UserCustomTalentAlert,
  UserCustomTalentAlertCreate,
  UserCustomTalentAlertUpdate,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class UserAlertsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readUserAlerts() {
    return super.read<{ data: UserAlerts }>({
      endpoint: '/alerts',
      method: 'GET',
    });
  }

  async updateUserFixedAlerts(body: UserFixedAlerts) {
    return super.write<{ data: UserFixedAlerts }>({
      endpoint: '/alerts/fixed',
      method: 'PUT',
      body,
    });
  }

  async createCustomTalentAlert(body: UserCustomTalentAlertCreate) {
    return super.write<{ data: UserCustomTalentAlert }>({
      endpoint: '/alerts/custom/talent',
      method: 'POST',
      body,
    });
  }

  async updateCustomTalentAlert(id: string, body: UserCustomTalentAlertUpdate) {
    return super.write<{ data: null }>({
      endpoint: `/alerts/custom/talent/${id}`,
      method: 'PUT',
      body,
    });
  }

  async deleteCustomTalentAlert(candidateId: string) {
    return super.write<{ data: null }>({
      endpoint: `/alerts/custom/talent/${candidateId}`,
      method: 'DELETE',
    });
  }

  async refreshUserAlerts() {
    return super.invalidate('/alerts');
  }
}

export const UserAlertsApi = new UserAlertsApiClass();
